'use strict';

var React = require('react');

var SvgLightbulbIcon = function SvgLightbulbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58 4.167a.75.75 0 0 0-1.06 1.06l.353.354a.75.75 0 1 0 1.061-1.06l-.353-.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.657 5.404a.75.75 0 0 0-1.06-1.06l-.354.353a.75.75 0 1 0 1.06 1.06l.354-.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.474 5.998a4.987 4.987 0 0 1 7.052 0c.95.95 1.46 2.103 1.46 3.298 0 1.194-.51 2.348-1.46 3.297a4.45 4.45 0 0 1-.053.053c-.473.455-.723.866-.723 1.24v1.114a2.5 2.5 0 0 1-2.5 2.5h-.5a2.5 2.5 0 0 1-2.5-2.5v-1.114c0-.374-.25-.785-.722-1.24a4.312 4.312 0 0 1-.054-.053c-.95-.95-1.46-2.103-1.46-3.297 0-1.195.51-2.349 1.46-3.298Zm5.992 1.06a3.487 3.487 0 0 0-4.932 0c-.705.707-1.02 1.492-1.02 2.238 0 .745.315 1.53 1.02 2.236l.034.033c.366.353.788.836 1.015 1.435h2.834c.227-.6.649-1.082 1.015-1.435l.034-.033c.705-.706 1.02-1.491 1.02-2.236 0-.746-.315-1.531-1.02-2.237Zm-1.216 7.442h-2.5v.5a1 1 0 0 0 1 1h.5a1 1 0 0 0 1-1v-.5Z"
  }));
};
SvgLightbulbIcon.displayName = "LightbulbIcon";

exports.SvgLightbulbIcon = SvgLightbulbIcon;
